import { serviceRequest } from 'utils/http';
import {
  ReferralService,
  RequestMedicalRecordsDto,
  RequestMedicalRecordsResponseDto,
} from 'common/api';

export async function requestMedicalRecordsAPI(params: {
  referralId: string;
  consentConfirmed: boolean;
}): Promise<RequestMedicalRecordsResponseDto> {
  const requestBody: RequestMedicalRecordsDto = {
    consentConfirmed: params.consentConfirmed,
  };

  return serviceRequest(() =>
    ReferralService.referralControllerRequestMedicalRecords(
      params.referralId,
      requestBody
    )
  );
}
